<div class="activity-details">
    <c-auto-form config="setTagCtrl.autoFormConfig"></c-auto-form>
</div>
